export default {
  title: "Card Transactions (Deprecated)",
  subtitle: "",
  paragraphs: ['This section is only relevant if you integrated credit cards in Brazil before August 2025. If you\'re integrating for the first time, refer to the "Credit Card Transactions Brazil" section above.'],
  path: "deprecated_card_transactions",
  request: {},  
}


// WEBPACK FOOTER //
// ./src/components/documentation/data/Deprecated/Transaction/CreditCardOverview.js